import { render } from "./WeSlider.vue?vue&type=template&id=0d55d60c"
import script from "./WeSlider.vue?vue&type=script&lang=js"
export * from "./WeSlider.vue?vue&type=script&lang=js"

import "./WeSlider.vue?vue&type=style&index=0&id=0d55d60c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__